import { render, staticRenderFns } from "./Behavior.vue?vue&type=template&id=f92cd67e&scoped=true"
import script from "./Behavior.vue?vue&type=script&lang=js"
export * from "./Behavior.vue?vue&type=script&lang=js"
import style0 from "./Behavior.vue?vue&type=style&index=0&id=f92cd67e&prod&scoped=scoped&lang=less"
import style1 from "./Behavior.vue?vue&type=style&index=1&id=f92cd67e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92cd67e",
  null
  
)

export default component.exports